import { render, staticRenderFns } from "./quotaSummary.vue?vue&type=template&id=71042dde&scoped=true&"
import script from "./quotaSummary.vue?vue&type=script&lang=js&"
export * from "./quotaSummary.vue?vue&type=script&lang=js&"
import style0 from "./quotaSummary.vue?vue&type=style&index=0&id=71042dde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71042dde",
  null
  
)

export default component.exports